import {
  TAvailability,
  TBookingPricingStructure,
  TCalendarBooking,
  TLodging,
  TLodgingPricingStructure,
} from "../types/types";

export function getAllBookingsForDate(
  bookings: TCalendarBooking[],
  calendarDate: string,
): TCalendarBooking[] | [] {
  if (!bookings || bookings.length === 0) {
    return [];
  }
  const bookingsForCalendarDate: TCalendarBooking[] = [];
  const currentDate = new Date(calendarDate);
  for (let i = 0; i < bookings.length; i++) {
    const startDate = new Date(bookings[i].start_date);
    const endDate = new Date(bookings[i].end_date);

    if (currentDate >= startDate && currentDate <= endDate) {
      bookingsForCalendarDate.push(bookings[i]);
    }
  }

  return bookingsForCalendarDate;
}

export function getAllAvailabilityForDate(availability: TAvailability[], calendarDate: string): TAvailability[] | [] {
  
  if (!availability || availability.length === 0) {
    return [];
  }
  const availabilityForCalendarDate: TAvailability[] = [];
  for (let i = 0; i < availability.length; i++) {
    if (availability[i].calendar_date === calendarDate) {
      availabilityForCalendarDate.push(availability[i]);
    }
  }

  return availabilityForCalendarDate;
}

export function getAllBookingsForDateRange(
  bookings: TCalendarBooking[],
  startDate: string,
  endDate: string,
): TCalendarBooking[] {
  if (!bookings || bookings.length === 0) {
    return [];
  }
  const bookingsForDateRange: TCalendarBooking[] = [];
  const start = new Date(startDate);
  const end = new Date(endDate);
  for (let i = 0; i < bookings.length; i++) {
    const bookingStart = new Date(bookings[i].start_date);
    const bookingEnd = new Date(bookings[i].end_date);
    if (bookingStart <= end && bookingEnd >= start) {
      bookingsForDateRange.push(bookings[i]);
    }
  }
  return bookingsForDateRange;
}

export function calculateTotalPrice(
  bookingPricing: TBookingPricingStructure,
  nights: number,
  lodgingPricing: TLodgingPricingStructure | undefined,
): number {
  console.log("NIGHTS", nights);
  if (lodgingPricing && lodgingPricing.unit && lodgingPricing.unit.unit_price) {
    return lodgingPricing.unit.unit_price * nights
  }
  const adults = bookingPricing.adults || 0;
  const children = bookingPricing.children || 0;
  const infants = bookingPricing.infants || 0;
  const pensioners = bookingPricing.pensioners || 0;
  const adultPrice = bookingPricing.adult_price || 0;
  const childPrice = bookingPricing.child_price || 0;
  const infantPrice = bookingPricing.infant_price || 0;
  const pensionerPrice = bookingPricing.pensioner_price || 0;
  return ((adults * adultPrice) + (children * childPrice) + (infants * infantPrice) + (pensioners * pensionerPrice)) * nights;
}

export function calculateTotalGuests(
  bookingPricing: TBookingPricingStructure,
): number {
  const adults = bookingPricing.adults || 0;
  const children = bookingPricing.children || 0;
  const infants = bookingPricing.infants || 0;
  const pensioners = bookingPricing.pensioners || 0;
  return (adults * 1) + (children * 1) + (infants * 1) + (pensioners * 1);
}
